import { StyleSheet } from 'react-native';
import { PALETTE, SIZES } from '../../../constants';

export default StyleSheet.create({
  root: {
  },
  rowRoot: {
    flexDirection: 'row',
    paddingVertical: 0,
    paddingHorizontal: SIZES.appHorizontalSpace,
  },
  rowMarker: {
    paddingVertical: 4,
  },
  rowContent: {
    flex: 1,
    flexDirection: 'column',
    paddingLeft: SIZES.appHorizontalSpace,
    paddingVertical: 6,
  },
  rowSeparator: {
    paddingLeft: 14,
    paddingRight: SIZES.appHorizontalSpace,
  },
  rowBorder: {
    height: 1,
    backgroundColor: PALETTE.primaryStrokeLine,
  },
  rowGroupRoot: {
    paddingTop: 13,
    paddingLeft: 20,
  },
  rowGroupWrapper: {
    // paddingHorizontal: 9,
  },
  rowGroupText: {
    color: PALETTE.secondaryText,
    marginTop: -1,
  },
});
